module.exports = __webpack_public_path__ + "img/19_28.44c8ddfe.png";